/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Operacje na URL
 *
 * @export
 * @class UrlTools
 * @extends {DateTools}
 */
import { DateTools } from "./DateTools.class";

export class UrlTools extends DateTools {
	constructor() {
		super();
	}
	// ****************************************************************************************************
	// naprawa URL: usuniecie parametrów zbędnych + oraz ujednolicenie kolejności parametrów
	// MASKA IN:	/ friendly_URL / typ_url / id_kategorii / atm-	 / f-			/ atcmi-	 / atcma-	 / atd-				 / atn-		/ pg-				/ st-	/ ?params
	// MASKA OUT: / baseUrl			/ urlType / category		 / brands / filters / minPrice / maxPrice / availability / newness / sales / pagination / sort / urlParams
	// ****************************************************************************************************
	fixUrlOrder(url) {
		var baseUrl, urlParams, splitUrl, splitUrlPrefix, splitUrlSufix, urlType;
		var category = '', pagination = '', sort = '', brands = '', filters = '', minPrice = '', maxPrice = '', availability = '', newness = '', sales = '';
		var fixedUrl = '';
		if ( url.includes('?') ) {
			splitUrl = url.split('?');
			baseUrl = splitUrl[0];
			urlParams = '?' + splitUrl[1];
		} else {
			baseUrl = url;
			urlParams = '';
		}
		//console.log('baseUrl:',baseUrl);
		//console.log('urlParams:',urlParams);
		if ( baseUrl.includes('/cat-') ) {
			splitUrl = baseUrl.split('/cat-');
			splitUrlPrefix = splitUrl[0];
			splitUrlSufix = '/k-' + splitUrl[1];
			urlType = '/cat-';
		} else if (baseUrl.includes('/items/')) {
			splitUrl = baseUrl.split('/items/');
			splitUrlPrefix = splitUrl[0];
			//splitUrlSufix = '/k-' + splitUrl[1]; // kategoria nie powinna występować po /items/
			splitUrlSufix = splitUrl[1];
			//urlType = '/items/'; // kategoria nie powinna występować po /items/ wiec to tworzy //
			urlType = '/items';
		} else {
			splitUrlPrefix = baseUrl;
			splitUrlSufix = '';
			urlType = '';
		}
		//console.log('splitUrlPrefix:',splitUrlPrefix);
		//console.log('splitUrlSufix:',splitUrlSufix);
		//console.log('urlType:',urlType);
		splitUrl = splitUrlSufix.split('/');
		splitUrl.forEach(function (item, index) {
			if (splitUrl[index].includes('k-'))
				category = splitUrl[index].replace('k-', '');
			else if (splitUrl[index].includes('pg-'))
				pagination = '/' + splitUrl[index];
			else if (splitUrl[index].includes('st-'))
				sort = '/' + splitUrl[index];
			else if (splitUrl[index].includes('atm-'))
				brands = '/' + splitUrl[index];
			else if (splitUrl[index].includes('f-'))
				filters = '/' + splitUrl[index];
			else if (splitUrl[index].includes('atcmi-'))
				minPrice = '/' + splitUrl[index];
			else if (splitUrl[index].includes('atcma-'))
				maxPrice = '/' + splitUrl[index];
			else if (splitUrl[index].includes('atd-'))
				availability = '/' + splitUrl[index];
			else if (splitUrl[index].includes('atn-'))
				newness = '/' + splitUrl[index];
			else if (splitUrl[index].includes('atw-'))
				sales = '/' + splitUrl[index];
		});
		fixedUrl = splitUrlPrefix + urlType + category + brands + filters + minPrice + maxPrice + availability + newness + sales + pagination + sort + urlParams;
//console.log(url,fixedUrl);
//console.log(splitUrlPrefix,urlType,category,brands,filters,minPrice,maxPrice,availability,newness,sales,pagination,sort,urlParams)
		return fixedUrl;
	}
	// ****************************************************************************************************
	// wyciągnięcie nr sortu z URL
	// ****************************************************************************************************
	getSortFromUrl(url) {
		var that = this;
		var splitUrl;
		var retUrl = 0;
		if (url.includes('/st-')) {
			splitUrl = url.split('/');
			splitUrl.forEach(function (item, index) {
				if (splitUrl[index].includes('st-'))
					retUrl = Number(splitUrl[index].replace('st-', ''));
			});
		}
		return retUrl;
	}
	// ****************************************************************************************************
	// usunięcie parametrow domyslnych
	// ****************************************************************************************************
	removeDefaultParameters(url) {
		var that = this;
		if ( url.includes('&current_action=ajax') )
			url = url.replace('&current_action=ajax', '' );
		else if ( url.includes('current_action=ajax&') )
			url = url.replace('current_action=ajax&', '');
		else
			url = url.replace('?current_action=ajax', '');

		if ( url.includes('/pg-1') && url.match(/\/pg-\d{2,3}/) === null ) // tylk pg-1  a nie pg-10 itd
			url = url.replace('/pg-1', '');

		return url.replace('/st-0', '');
	}
	// ****************************************************************************************************
	// wyciągnięcie wartości konkretnego parametru
	// ****************************************************************************************************
	getUrlParameter(searchParam) {
		var params = decodeURIComponent(window.location.search.substring(1)).split('&'), parameter, i;
		for (i = 0; i < params.length; i++) {
			parameter = params[i].split('=');
			if (parameter[0] === searchParam) {
				return (parameter[1] === undefined) ? null : parameter[1];
			}
		}
		return false;
	}
	// ****************************************************************************************************
	// usunięcie parametrów filtrowania z URL
	// ****************************************************************************************************
	removeFiltersParameterFromUrl(baseUrl) {
		var urlParams, splitUrl, splitUrlPrefix, splitUrlSufix, urlType;
		var category = '', pagination = '', sort = '';
		if (baseUrl.includes('/cat/')) {
			splitUrl = baseUrl.split('/cat/');
			splitUrlPrefix = splitUrl[0];
			splitUrlSufix = '/' + splitUrl[1];
			urlType = '/cat';
		} else if (baseUrl.includes('/cat-')) {
			splitUrl = baseUrl.split('/cat-');
			splitUrlPrefix = splitUrl[0];
			splitUrlSufix = '/k-' + splitUrl[1];
			urlType = '/cat';
		} else if (baseUrl.includes('/items/')) {
			splitUrl = baseUrl.split('/items/');
			splitUrlPrefix = splitUrl[0];
			splitUrlSufix = '/' + splitUrl[1];
			urlType = '/items';
		} else if (baseUrl.includes('/new/')) { // nowosci
			splitUrl = baseUrl.split('/new/');
			splitUrlPrefix = splitUrl[0];
			splitUrlSufix = '/' + splitUrl[1];
			urlType = '/items';
		} else {
			splitUrlPrefix = baseUrl;
			splitUrlSufix = '';
			urlType = '';
		}
		splitUrl = splitUrlSufix.split('/');
		splitUrl.forEach(function (item, index) {
			if (item.includes('k-'))
				category = '-' + item.replace('k-','');
			else if (item.includes('pg-'))
				pagination = '/' + item;
			else if (item.includes('st-'))
				sort = '/' + item;
		});
		return splitUrlPrefix + urlType + category + pagination + sort;
	}
	// ****************************************************************************************************
	// wyciągnięcie parmetrów filtrowania z URL
	// ****************************************************************************************************
	getFilteringParamsFromUrl(url) {
		//console.log('getFilteringParamsFromUrl',url);
		var that = this;
		url = url.replace(/\/k-\w+/, '').replace(/\/cat-\w+/, '/cat').replace(/\/pg-\w+/, '').replace(/\/st-([0-9])/, ''); // usuniecie parametru kategorii, paginacji i sortowania
		if (url.includes('/cat/'))
			return url.split('/cat')[1];
		if (url.includes('/items/'))
			return url.split('/items')[1];
		return '';
	}
	// ****************************************************************************************************
	// używane w zdarzeniu onClick z html - wymagane data-href
	// ****************************************************************************************************
	loadPage(e) {
		window.location.href = $(e).data('href');
	}
	// ****************************************************************************************************
	// używane w zdarzeniu onClick z html - wymagane data-href
	// ****************************************************************************************************
	initClickAction() {
		$('.clickAction').each(function (i, e) {
			$(e).off().on('click', function (event) {
				event.stopPropagation();
				window.location.href = $(this).data('href');
			});
		});
	}

	/**
	 * usuwanie parametrow z URL
	 *
	 * @returns string
	 * @memberof UrlTools
	 */
	removeDisallowedParametersFromURL(){
		let disallowedParams = ['msg=', '_ga=', '_gac=', '_gl='];

		let params = location.href.split('?')[1];
		let filteredParams = [];
		let removeParam = false;

		if ( typeof params != 'undefined' ) {
			if ( params.includes('#') ) // usuniecie hash
				params = params.split('#')[0];

			params.split('&').forEach(function (param) {
				removeParam = false;

				disallowedParams.forEach(function (dis){
					if ( param.includes(dis) ) {
						removeParam = true;
					}
				});
				if ( !removeParam ) { // parametry dozwolone
					filteredParams.push(param);
				}
			});

			if ( filteredParams.length > 0 ) {
				if ( filteredParams.length > 1 )
					return '?'+filteredParams.join('&');
				else
					return '?'+filteredParams[0];
			}
		}

		return '';
	}
	/**
	* usuwanie parametrow z URL
	*
	* @returns string
	* @memberof UrlTools
	*/
	getParameterValueFromURLbyName(name){
		let params = location.href.split('?')[1];

		var res = false;

		if ( typeof params != 'undefined' ) {
			params.split('&').forEach(function (param) {
				if ( param.includes(name) ) {
					console.log(param.split("=")[1]);
					res = param.split("=")[1];
				}
			});
		}

		return res;
	}
	/**
	 * modyfikacja URL przegladarki
	 *
	 * @returns string
	 * @memberof UrlTools
	 */
	updateBrowserHistory(url){
		let that = this;
		history.replaceState({
			listingType: that.getCookie('productsListingStyle')
		}, document.title, url);
	}
	/**
	 * zdekdowanie pełnrgo adresu URL
	 *
	 * @returns object
	 * @memberof UrlTools
	 */
	decodeFullUrl(url) {
		let ret = new Object;
		ret.host = url.split(DOMAIN+'/')[0]+DOMAIN;
		ret.path = url.split(DOMAIN+'/')[1];
		ret.search = '';
		if ( ret.path.includes('?') ) {
			ret.search = '?'+ret.path.split('?')[1];
			ret.path = ret.path.split('?')[0];
		}
		return ret;
	}
}